
    const CART_PATHS = [
      "/cart/add", "/cart/update", "/cart/change", "/cart/clear",
      "/cart/add.js", "/cart/update.js", "/cart/change.js", "/cart/clear.js"
    ];


    function isCartRequest(url) {
      if (!url) return false;
      const last = url.split("/").pop();
      // Remove the query string from the last part
      const lastWithoutQuery = last.split("?")[0];
      return CART_PATHS.includes("/cart/" + lastWithoutQuery);
    }

    function debounce(fn, delay) {
        let timer;
        return function (...args) {
        clearTimeout(timer);
        timer = setTimeout(() => fn.apply(this, args), delay);
        };
    }


    // function moveUpsell(){
    //     if(document.querySelector('.spurit-occ3__upsell') && !document.querySelector('.spurit-occ3__upsell').closest('.spurit-occ3__slide-drawer-footer')){
    //         document.querySelector('.spurit-occ3__slide-drawer-footer').insertAdjacentElement("afterbegin", document.querySelector('.spurit-occ3__upsell'))
    //     }
    // }

    async function renderShippingComponent() {
        if(document.querySelector('.spurit-occ3__empty-cart') || document.querySelector('.shipping-protection') || document.querySelector("#occ3-drawer")?.classList.contains('loading')) return;
        try {
          document.querySelector("#occ3-drawer")?.classList.add('loading');
          const shippingProtectionComponent = await createShippingProtectionComponent();
          if(!shippingProtectionComponent) return;
          document.querySelector(".occ3-display-block .spurit-occ3__slide-drawer-footer")?.insertAdjacentElement('afterbegin', shippingProtectionComponent);
            //moveUpsell()
        } catch (error) {
          console.error(error);
        }finally {
          document.querySelector("#occ3-drawer")?.classList.remove('loading');
        }
      
    }



    const debouncedRenderShippingComponent = debounce(renderShippingComponent, 800);

    // // ---- Patch XHR ----
    // if (window.XMLHttpRequest) {
    //   const origOpen = XMLHttpRequest.prototype.open;
    //   XMLHttpRequest.prototype.open = function(method, url, ...rest) {
    //     this.addEventListener("load", () => {
    //       if (isCartRequest(url)) {
    //         debouncedRenderShippingComponent();
    //       }
    //     });
    //     return origOpen.call(this, method, url, ...rest);
    //   };
    // }

    // if (window.fetch) {
    //   const origFetch = window.fetch;
    //   window.fetch = function(...args) {
    //     const url = args[0];
    //     const p = origFetch.apply(this, args);

    //     if (isCartRequest(url)) {
    //       p.then(resp => {
    //         resp.clone().json().then(data => {
    //           debouncedRenderShippingComponent();
    //         }).catch(() => {});
    //       });
    //     }
    //     return p;
    //   };
    // }


  async function createShippingProtectionComponent(){
    const shippingProtection = await fetch('/?sections=shipping-protection');
    const shippingProtectionData = await shippingProtection.json();

    if(!shippingProtectionData["shipping-protection"]) return;

    const shippingProtectionComponent = document.createElement('div');
    shippingProtectionComponent.innerHTML = shippingProtectionData["shipping-protection"];
    return shippingProtectionComponent.querySelector('shipping-protection');
  }


  setInterval(() => {
    // If the cart is not opened or is opened but empty, return
    if(document.querySelector('.spurit-occ3__empty-cart') || !document.querySelector(".occ3-display-block .spurit-occ3__slide-drawer-footer")) return;

    // If the shipping protection component is already rendered, return
    if(document.querySelector(".occ3-display-block .spurit-occ3__slide-drawer-footer")?.innerHTML.includes('shipping-protection')) return;

    // Render the shipping protection component
    debouncedRenderShippingComponent();
  }, 1000);



  if (!window.customElements.get('shipping-protection')) {
    class ShippingProtection extends HTMLElement {
        constructor() {
        super();
        }

        connectedCallback() {

        if(window.shipping_protection_running == true){
            return;
        }else{
            window.shipping_protection_running = true;
        }
        

        // Default to enabled if no session value
        if (sessionStorage.getItem('noprotection') === null || sessionStorage.getItem('noprotection') == 'false') {
            sessionStorage.setItem('noprotection', 'false');

            const link = this.querySelector('[data-protection-id]');
            if (link) {
            link.classList.add('active');
            }

            // Kick off logic to add protection if needed
            this.handleProtectionLogic();
        }

        this.addEventListeners();
        }

        get variants() {
        try {
            return JSON.parse(this.dataset.variants || '[]');
        } catch {
            return [];
        }
        }

        get cartTotal() {
        return parseInt(this.dataset.cartTotal || '0', 10);
        }

        get currentProtectionId() {
        return this.dataset.currentProtectionId;
        }

        get cartItemCount() {
        return parseInt(this.dataset.cartItemCount || '0', 10);
        }

        get bestVariant() {
        //   return this.variants.find(
        //     (variant) => parseInt(variant.sku || '0', 10) > this.cartTotal
        //   );
        return this.variants[0];    
        }

        async handleProtectionLogic() {

        if (sessionStorage.getItem('noprotection') === 'true'){
            window.shipping_protection_running = false
            return;
        }
        console.log('lets add protection')

        // Finds the best shipping protection variant based on the cart total
        const best = this.bestVariant;
        if (!best){
            window.shipping_protection_running = false
            return;
        }

        const current = this.currentProtectionId;

        if (current && current !== String(best.id)) {
            await this.updateCart({ [current]: 0, [best.id]: 1 });
        } else if (this.cartItemCount === 1 && current) {
            await this.updateCart({ [current]: 0 });
        } else if (this.cartItemCount > 0 && !current) {
            await this.updateCart({ [best.id]: 1 });
        }
        window.shipping_protection_running = false;
        }

        async updateCart(updates) {
        const payload = {
            updates,
        };

        const cartDrawer = document.querySelector('#occ3-drawer')
        try {
            // Set loading class on cart:
            if(cartDrawer) cartDrawer.classList.add('loading')
            const resp = await fetch('/cart/update.js', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
            },
            body: JSON.stringify(payload),
            })
            const data = await resp.json();
            if(Spurit && Spurit.OneClickCheckout3 && Spurit.OneClickCheckout3.cartDrawer.refresh()){
                Spurit.OneClickCheckout3.cartDrawer.refresh()
            }
        } catch (err) {
            console.error('Cart update error:', err)
        }finally{
            window.shipping_protection_running = false
            setTimeout(()=>{
                if(cartDrawer) cartDrawer.classList.remove('loading')
            }, 500)

        }
        }

        addEventListeners() {
        const link = this.querySelector('[data-protection-id]');
        if (!link) return;

        link.addEventListener('click', (e) => {
            e.preventDefault();

            const variantId = link.dataset.protectionId;
            const currentVariantId = this.currentProtectionId;
            if (!variantId) return;

            const isActive = link.classList.contains('active');
            const disabling = isActive;

            // Toggle `noprotection`
            sessionStorage.setItem('noprotection', disabling ? 'true' : 'false');

            // Toggle class
            link.classList.toggle('active', !disabling);

            // Add or remove the protection product
            if (disabling) {
            this.updateCart({ [currentVariantId]: 0 });
            } else {
            this.updateCart({ [variantId]: 1 });
            }

            // Rerun logic (should early return if `noprotection` now true)
            this.handleProtectionLogic();
        });
        }
    }

    customElements.define('shipping-protection', ShippingProtection);
    }